import React, { useState } from 'react'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'
import { Link, StartTrialButtonWithModal, CtaArrow } from 'newComponents'
import './styles.scss'

const PricingCard = ({ data }) => {
  const [priceToggleState, setPriceToggle] = useState('monthly')

  const priceToggle = (e) => {
    e.preventDefault()
    setPriceToggle(e.currentTarget.dataset.toggle)
  }

  const slideDownToFeatures = (e) => {
    e.preventDefault()

    scrollIntoView(document.querySelector('.pricing-feature-table'), {
      block: 'start',
      scrollMode: 'if-needed'
    })
  }

  const AddDollarSign = ({ price }) => {
    if (price.toLowerCase() !== 'contact sales') {
      return <span className="dollar-sign">$</span>
    }
    return ''
  }

  const HeaderButtons = ({ data }) => {
    if (data.url.length <= 0) {
      return (
        <StartTrialButtonWithModal
          cta={data.text}
          classes="button is-primary modal-trigger"
          trackEvent="Start 14-Day Free Trial Button Clicked"
          addArrow
        />
      )
    }
    return (
      <Link className="button is-primary button-link" to={data.url}>
        {data.text} <CtaArrow />
      </Link>
    )

  }

  return (
    <div className="pricing-cards">
      <div className="pricing-toggle-container">
        <div className={`pricing-toggle-pill ${priceToggleState}`}>
          <a data-toggle="monthly" onClick={priceToggle} href="#">
            <span>Monthly</span>
          </a>
          <a data-toggle="annual" onClick={priceToggle} href="#">
            <span>Annual</span>
          </a>
        </div>
      </div>
      <div className="container">
        <div className="pricing-card-container">
          {data.map((card) => {
            const {
              items,
              primary: {
                card_color: cardColor,
                card_title: cardTitle,
                pricing_detail: pricingDetail,
                monthly_price: monthlyPrice,
                monthly_price_cent: monthlyPriceCent,
                monthly_price_suffix: monthlyPriceSuffix,
                annual_price: annualPrice,
                annual_price_cent: annualPriceCent,
                annual_price_suffix: annualPriceSuffix,
                included_feature_list_title: featureTitle,
                cta_text: ctaText,
                cta_url: ctaUrl
              }
            } = card
            const links = {
              text: ctaText.text,
              url: ctaUrl.url
            }
            return (
              <div key={cardTitle.text} className={`pricing-card ${cardColor} ${cardTitle.text.toLowerCase()}`}>
                <div className="pricing-card-inner">
                  <h3 className="pricing-card-title">{cardTitle.text}</h3>
                  <div className={`price-container ${priceToggleState}`}>
                    <span className="price-monthly">
                      <AddDollarSign price={monthlyPrice.text} />
                      <span className="dollar-amount">{monthlyPrice.text}</span>
                      {monthlyPriceCent.text && <span className="cent-amount">{monthlyPriceCent.text}</span>}
                      <span className="price-suffix">{monthlyPriceSuffix.text}</span>
                    </span>
                    <span className="price-annual">
                      <AddDollarSign price={annualPrice.text} />
                      <span className="dollar-amount">{annualPrice.text}</span>
                      {annualPriceCent && <span className="cent-amount">{annualPriceCent.text}</span>}
                      <span className="price-suffix">{annualPriceSuffix.text}</span>
                    </span>
                  </div>
                  <p className="pricing-detail">{pricingDetail.text}</p>
                  <HeaderButtons data={links} />
                  <div className="pricing-feature-list-container">
                    <h6>{featureTitle.text}</h6>
                    <ul className="pricing-feature-list">
                      {items.map((featureList) => {
                        const {
                          included_feature_list_item: { text: featureItemText }
                        } = featureList
                        return (
                          <li key={featureItemText} className="pricing-feature-list-item">
                            {featureItemText}
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
      <div className="see-all-features-container">
        <a onClick={slideDownToFeatures} href="#">
          See All Features <span className="down-caret" />
        </a>
      </div>
    </div>
  )
}

export default PricingCard
